import React from 'react'

const Layout = ({children}) => {
  return (
      <div className='bg-gray-200 h-screen'>{ children}</div>
  )
}

export default Layout